import { configService } from "../utils/ConfigService";
import { getService } from "../utils/Request";

export function GetAllCountries() {
  const profileEndpoint = configService.getProfileEndpoint();
  return getService()({
    url: "/City/GetCountries",
    method: "get",
    baseURL: profileEndpoint + "/api",
  });
}

export interface AutoCompleteInputType {
  name: string;
  searchType?: string;
  count?: number;
}

export function CityAutoComplete(data: AutoCompleteInputType) {
  const profileEndpoint = configService.getProfileEndpoint();
  return getService()({
    url: `/City/CityAutoComplete?name=${data.name}&searchType=${data.searchType}`,
    method: "get",
    baseURL: profileEndpoint + "/api",
  });
}
